import { render, staticRenderFns } from "./PedigreeRegistration.vue?vue&type=template&id=01f08339"
import script from "./PedigreeRegistration.vue?vue&type=script&lang=ts"
export * from "./PedigreeRegistration.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./pedigree.fr.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fcodebuild%2Foutput%2Fsrc3225659580%2Fsrc%2Fgit-codecommit.eu-west-3.amazonaws.com%2Fv1%2Frepos%2Farqana-front-myarqana%2Fsrc%2Fviews%2Fregistration%2Fpedigree%2FPedigreeRegistration.vue&external"
if (typeof block0 === 'function') block0(component)
import block1 from "./pedigree.en.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fcodebuild%2Foutput%2Fsrc3225659580%2Fsrc%2Fgit-codecommit.eu-west-3.amazonaws.com%2Fv1%2Frepos%2Farqana-front-myarqana%2Fsrc%2Fviews%2Fregistration%2Fpedigree%2FPedigreeRegistration.vue&external"
if (typeof block1 === 'function') block1(component)

export default component.exports